import { render, staticRenderFns } from "./ModalOrganizar.vue?vue&type=template&id=41222341"
import script from "./ModalOrganizar.vue?vue&type=script&lang=js"
export * from "./ModalOrganizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports